import React from "react";
import cloneDeep from "lodash/cloneDeep";
import { Trans } from "react-i18next";
import i18n from "i18n";
import { ExternalLink } from "components/common";
import { Checkbox, Col, FormGroup, HelpBlock, Row, Input } from "components/bootstrap";
import * as FormsUtils from "util/FormsUtils";
import TemplateFieldValueProviderPreview from "./TemplateFieldValueProviderPreview";
const t = (key) => i18n.t(key, { ns: "event_definitions" });
const JmteLink = ({ children = void 0 }) => /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://cdn.rawgit.com/DJCordhose/jmte/master/doc/index.html" }, children);
const _TemplateFieldValueProviderForm = class _TemplateFieldValueProviderForm extends React.Component {
  constructor() {
    super(...arguments);
    this.handleChange = (event) => {
      const { config, onChange } = this.props;
      const { name } = event.target;
      const value = FormsUtils.getValueFromInput(event.target);
      const nextProviders = cloneDeep(config.providers);
      const templateProvider = nextProviders.find((provider) => provider.type === _TemplateFieldValueProviderForm.type);
      templateProvider[name] = value;
      if (name === "require_values" && value) {
        templateProvider.exclude_empty_fields = true;
      }
      onChange({ ...config, providers: nextProviders });
    };
  }
  render() {
    var _a;
    const { config, validation } = this.props;
    const provider = config.providers.find((p) => p.type === _TemplateFieldValueProviderForm.type);
    const helpText = /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
      Trans,
      {
        i18n,
        ns: "event_definitions",
        i18nKey: "template_provider_form.template_help",
        components: { jmteLink: /* @__PURE__ */ React.createElement(JmteLink, null) }
      }
    ));
    return /* @__PURE__ */ React.createElement(Row, { className: "row-sm" }, /* @__PURE__ */ React.createElement(Col, { md: 7, lg: 6 }, /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "template-provider-template",
        name: "template",
        type: "text",
        label: t("template_provider_form.template"),
        onChange: this.handleChange,
        value: provider.template || "",
        bsStyle: validation.errors.template ? "error" : null,
        help: validation.errors.template || helpText
      }
    ), /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(
      Checkbox,
      {
        id: "lookup-message-require-values",
        name: "require_values",
        checked: provider.require_values,
        onChange: this.handleChange
      },
      t("template_provider_form.require_values")
    ), /* @__PURE__ */ React.createElement(HelpBlock, null, t("template_provider_form.require_values_help"))), /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(
      Checkbox,
      {
        id: "template-provider-exclude-empty-fields",
        name: "exclude_empty_fields",
        disabled: provider.require_values,
        checked: (_a = provider.exclude_empty_fields) != null ? _a : true,
        onChange: this.handleChange
      },
      t("template_provider_form.exclude_empty_fields")
    ), /* @__PURE__ */ React.createElement(HelpBlock, null, t("template_provider_form.exclude_empty_fields_help")))), /* @__PURE__ */ React.createElement(Col, { md: 5, lgOffset: 1 }, /* @__PURE__ */ React.createElement(TemplateFieldValueProviderPreview, null)));
  }
};
_TemplateFieldValueProviderForm.type = "template-v1";
_TemplateFieldValueProviderForm.defaultConfig = {
  template: "",
  exclude_empty_fields: true
};
_TemplateFieldValueProviderForm.requiredFields = ["template"];
let TemplateFieldValueProviderForm = _TemplateFieldValueProviderForm;
export default TemplateFieldValueProviderForm;
